export class DebugFirebaseWrapper {
    constructor(firebase, context) {
        this.firebase = firebase;
        this.context = Object.assign({}, context);
    }
    onValue(path, callback) {
        return this.firebase.onValue(path, (snapshot) => {
            globalThis.Debug.pushDebugContext(this.context);
            callback(snapshot);
            globalThis.Debug.popDebugContext(this.context);
        });
    }
    onChildAdded(path, callback) {
        return this.firebase.onChildAdded(path, (snapshot, previousChildName) => {
            globalThis.Debug.pushDebugContext(this.context);
            callback(snapshot, previousChildName);
            globalThis.Debug.popDebugContext(this.context);
        });
    }
    onChildChanged(path, callback) {
        return this.firebase.onChildChanged(path, (snapshot, previousChildName) => {
            globalThis.Debug.pushDebugContext(this.context);
            callback(snapshot, previousChildName);
            globalThis.Debug.popDebugContext(this.context);
        });
    }
    onChildRemoved(path, callback) {
        return this.firebase.onChildRemoved(path, (snapshot) => {
            globalThis.Debug.pushDebugContext(this.context);
            callback(snapshot);
            globalThis.Debug.popDebugContext(this.context);
        });
    }
    set(path, value) {
        return this.firebase.set(path, value);
    }
    get(path) {
        return this.firebase.get(path);
    }
    runTransaction(path, transactionUpdate, options) {
        return this.firebase.runTransaction(path, transactionUpdate, options);
    }
    remove(path) {
        return this.firebase.remove(path);
    }
    update(path, values) {
        return this.firebase.update(path, values);
    }
    onDisconnect(path) {
        return this.firebase.onDisconnect(path);
    }
}
//# sourceMappingURL=DebugFirebaseWrapper.js.map